export default __webpack_public_path__ + "static/media/magnifying_glass.85a1aac4.svg";